/** Standalone Inspections list.
 *
 * Campaign sessions live INSIDE their campaign now (the campaign
 * detail page's own "Sessions" tab, `SessionsTable` scoped to that one
 * campaign) — this top-level page shows ONLY sessions with no campaign
 * at all (`scope="standalone"`, i.e. `?campaign=none` server-side).
 * Before this split the two were mixed here with a "Campaign" filter
 * (including a "Standalone (no campaign)" choice) that made it easy to
 * lose track of which sessions belonged where; now scope is fixed, not
 * a toggle, and every session has exactly one home.
 */
import { useTranslation } from "react-i18next";

import { AppLayout } from "@/components/AppLayout";
import { PermissionGate } from "@/components/PermissionGate";
import { SessionsTable } from "@/modules/sessions/SessionsTable";
import { CreateSessionButton, TrySampleButton } from "@/modules/dashboard";

export default function SessionsListPage() {
  const { t } = useTranslation();

  return (
    <AppLayout
      title={t("sessionsList.title")}
      description={t("sessionsList.description")}
      headerAction={
        <PermissionGate perm="session.create">
          <div className="flex items-center gap-2">
            <TrySampleButton />
            <CreateSessionButton />
          </div>
        </PermissionGate>
      }
    >
      <PermissionGate
        perm="session.read"
        fallback={
          <p className="card text-sm text-nb-text-2">
            {t("admin.noPermission")}
          </p>
        }
      >
        <SessionsTable scope="standalone" />
      </PermissionGate>
    </AppLayout>
  );
}
